import { FORM_STUDIO_COPY } from '../constants/formStudioConfig';

function readGeneralError(payload) {
  const generalError = payload?.data?.general_error ?? payload?.general_error;
  if (!generalError) {
    return null;
  }
  if (typeof generalError === 'string') {
    return generalError;
  }
  if (typeof generalError?.msg === 'string') {
    return generalError.msg;
  }
  return null;
}

/**
 * Maps Form Studio API failures to user-facing copy.
 *
 * @param {object|undefined|null} payload Axios response body or nested data
 * @returns {string}
 */
export function extractFormStudioApiError(payload) {
  const code = readGeneralError(payload);

  if (code === 'not_permitted') {
    return FORM_STUDIO_COPY.permissionDenied;
  }

  if (typeof code === 'string' && code.trim()) {
    return code;
  }

  return FORM_STUDIO_COPY.saveError;
}

/**
 * @param {object|undefined|null} response Axios response
 * @returns {boolean}
 */
export function isFormStudioApiSuccess(response) {
  return response?.data?.status === true;
}
